// The bind between the url parameter name and a more precise variable name

const URL_PARAMETERS_TO_VARIABLE = Object.create(null);
const VARIABLE_TO_URL_PARAMETERS = Object.create(null);

function addMap(url_parameter, variable_name) {
  URL_PARAMETERS_TO_VARIABLE[url_parameter] = variable_name;
  VARIABLE_TO_URL_PARAMETERS[variable_name] = url_parameter;
}

addMap('eid', 'enterprise_id');
addMap('lid', 'lawyer_id');
addMap('oid', 'law_office_id');

module.exports = {
  URL_PARAMETERS_TO_VARIABLE,
  VARIABLE_TO_URL_PARAMETERS,
};